import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicFormComponent } from './dynamic-form.component';

import { SharedComponentsModule } from 'core/shared-components';
import {
  AutocompleteFormControlModule,
  CheckboxFormControlModule,
  ChecklistFormControlModule,
  DateFormControlModule,
  EmailFormControlModule,
  PasswordFormControlModule,
  PhoneFormControlModule,
  SelectFormControlModule,
  SliderFormControlModule,
  TextAreaFormControlModule,
  TextFormControlModule
} from './form-controls';

@NgModule({
  declarations: [DynamicFormComponent],
  exports: [DynamicFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PhoneFormControlModule,
    EmailFormControlModule,
    CheckboxFormControlModule,
    AutocompleteFormControlModule,
    SelectFormControlModule,
    TextFormControlModule,
    PasswordFormControlModule,
    DateFormControlModule,
    SliderFormControlModule,
    TextAreaFormControlModule,
    ChecklistFormControlModule,
    SharedComponentsModule
  ]
})
export class DynamicFormModule { }
